import { checkResponse } from "src/components/js/statics1";

export default class firebaseClass {
  constructor(personId) {
    this.personId = personId;
  }

  async addPersonDevice(FCMToken, token, isMobile) {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        personId: this.personId,
        FCMToken: FCMToken,
        isMobile: isMobile,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/firebase/addPersonDevice",
      requestOptions
    );
    return (await checkResponse(response, "firebaseClass.js:addPersonDevice")).data;
  }
  async removeAllPersonDevices(token) {
    return await this.removeDevice(null, token);
  }
  async removeDevice(FCMToken, token) {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        personId: this.personId,
        FCMToken: FCMToken,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/firebase/removeDevice",
      requestOptions
    );
    return (await checkResponse(response, "firebaseClass.js:removeDevice")).data;
  }
  async countPersonDevices(token) {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        personId: this.personId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/firebase/countPersonDevices",
      requestOptions
    );
    const cResponse = await checkResponse(response, "firebaseClass.js:countPersonDevices");
    return cResponse.data.returnValue;
  }

  async fetchPersonDevices(token) {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        personId: this.personId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/firebase/fetchPersonDevices",
      requestOptions
    );
    return (await checkResponse(response, "firebaseClass.js:fetchPersonDevices")).data;
  }
}
export async function sendMessageToAdminDevices(title, body, keikkaId, token, collapseKey = null) {
  return await sendMessageToPersonDevices(title, body, 10, keikkaId, token, collapseKey);
}

export async function sendMessageToPersonDevices(
  title,
  body,
  personId,
  keikkaId,
  token,
  collapseKey = keikkaId,
  lastDate = null,
  priority = "high",
  ttl_s = 43200
) {
  if (personId != 10) {
    sendMessageToAdminDevices(title, body, keikkaId, token, collapseKey);
  }
  // get how many seconds until lastDate
  if (lastDate) ttl_s = Math.floor((lastDate - new Date()) / 1000);
  if (ttl_s < 360) ttl_s = 360;

  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      title: title,
      body: body,
      url: "/tilaus/" + keikkaId,
      keikkaId: keikkaId,
      personId: personId,
      ttl: ttl_s,
      collapseKey: collapseKey,
      priority: priority,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/firebase/sendMessageToPersonDevices",
    requestOptions
  );
  return (await checkResponse(response, "firebaseClass.js:sendMessageToPersonDevices")).data;
}

export async function getAllPersonNotifications(token, personId, keikkaTilaId) {
  const body = {
    personId: personId,
    keikkaTilaId: keikkaTilaId,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/firebase/getAllPersonNotifications",
    requestOptions
  );
  const cResponse = await checkResponse(response, "firebaseClass.js:getAllPersonNotifications");
  return cResponse.data;
}

export async function getNotifications(token, keikkaId, personId, keikkaTilaId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaId: keikkaId,
      personId: personId,
      keikkaTilaId: keikkaTilaId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/firebase/getNotifications",
    requestOptions
  );
  return (await checkResponse(response, "firebaseClass.js:getNotifications")).data;
}

export async function markNotificationsAsRead(token, keikkaId, personId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaId: keikkaId,
      personId: personId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/firebase/markNotificationsAsRead",
    requestOptions
  );
  return (await checkResponse(response, "firebaseClass.js:markNotificationsAsRead")).data;
}
